import type { WidgetProps } from "../registry";
import type { ProfileSavePayload } from "../../../generated-api";

export type ProfileSaveResult = {
  confirmed: boolean;
};

export function ProfileSaveWidget({
  payload,
  onComplete,
}: WidgetProps<ProfileSavePayload>) {
  const hasRows =
    (payload?.history?.length ?? 0) > 0 || (payload?.notes?.length ?? 0) > 0;

  return (
    <div className="flex flex-col gap-3 mt-1 border border-border-subtle rounded-xl p-3 text-sm">
      {payload?.longTermGoal && (
        <div>
          <div className="text-xs font-medium text-text-secondary mb-0.5">
            Long-term goal
          </div>
          <div className="text-text-primary">{payload.longTermGoal}</div>
        </div>
      )}

      {hasRows && (
        <div className="flex flex-col gap-1.5">
          {(payload?.history?.length ?? 0) > 0 && (
            <div className="text-xs text-text-secondary">
              <span className="font-medium text-text-primary">History:</span>{" "}
              {payload!
                .history!.map((h) => `${h.category}: ${h.description}`)
                .join("; ")}
            </div>
          )}
          {(payload?.notes?.length ?? 0) > 0 && (
            <div className="text-xs text-text-secondary">
              <span className="font-medium text-text-primary">Notes:</span>{" "}
              {payload!
                .notes!.map((n) => `${n.type} @ ${n.location}: ${n.note}`)
                .join("; ")}
            </div>
          )}
        </div>
      )}

      <div className="flex gap-2 pt-1">
        <button
          type="button"
          onClick={() =>
            onComplete({ confirmed: true } satisfies ProfileSaveResult)
          }
          className="px-4 py-2 text-sm font-medium rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition-colors"
        >
          Save profile
        </button>
        <button
          type="button"
          onClick={() =>
            onComplete({ confirmed: false } satisfies ProfileSaveResult)
          }
          className="px-4 py-2 text-sm font-medium rounded-lg border border-border-subtle text-text-primary hover:bg-bg-secondary transition-colors"
        >
          Not yet
        </button>
      </div>
    </div>
  );
}
